module.exports = __webpack_public_path__ + "img/benefits.c4209f48.png";